/*
* p-popupCenter
* Closes the popup when clicking anywhere outside of the card.
*/

const pPopupCenter = {
  cfg: {
    name: 'Popup Center',
    selectors: {
      root: '.p-popupCenter',
      inner: '.e-popover__inner',
      closeBtn: '[data-popover-close]',
    },
    classes: {
      isVisible: 'is-visible',
    },
    el: {
      $root: undefined,
      $inner: undefined,
      $closeBtn: undefined,
    },
  },

  setElements() {
    this.cfg.el.$root = document.querySelector(this.cfg.selectors.root);

    if (this.cfg.el.$root) {
      this.cfg.el.$inner = this.cfg.el.$root.querySelector(this.cfg.selectors.inner);
      this.cfg.el.$closeBtn = this.cfg.el.$root.querySelector(this.cfg.selectors.closeBtn);
    }
  },

  onDocumentClick(e) {
    const { $root, $inner, $closeBtn } = this.cfg.el;

    // only react while the popup is actually shown
    if (!$root.classList.contains(this.cfg.classes.isVisible)) return;

    // ignore clicks on the card itself
    if ($inner.contains(e.target)) return;

    // reuse the existing close handler (animation + cleanup)
    $closeBtn?.click();
  },

  addEventListeners() {
    document.addEventListener('click', this.onDocumentClick.bind(this));
  },

  init() {
    console.debug(`Init: ${this.cfg.name}`);
    this.setElements();

    if (this.cfg.el.$root && this.cfg.el.$closeBtn) {
      this.addEventListeners();
    }
  },
};

export default pPopupCenter;
